// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* damage + boost overlays */
.vignette-damage {
  position: absolute; inset: 0;
  background: radial-gradient(ellipse at center, transparent 52%, rgba(255, 30, 20, 0.55) 100%);
  opacity: 0; transition: opacity 0.1s ease;
}
.vignette-lowhull {
  position: absolute; inset: 0;
  background: radial-gradient(ellipse at center, transparent 58%, rgba(255, 30, 20, 0.4) 100%);
  opacity: 0;
}
.vignette-lowhull.on { animation: lowhull 1.2s ease-in-out infinite; }
@keyframes lowhull { 0%, 100% { opacity: 0.12; } 50% { opacity: 0.5; } }
.vignette-jump {
  position: absolute; inset: 0;
  background: radial-gradient(ellipse at center, rgba(210, 245, 255, 0.95) 0%, rgba(120, 200, 255, 0.6) 55%, transparent 100%);
  opacity: 0; transition: opacity 0.5s ease;
  pointer-events: none;
}

/* HUD resources */
.resource-line {
  display: flex; gap: 16px; margin-top: 4px;
  font-size: 12px; letter-spacing: 0.12em;
}
.resource-line span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.resource-line span i {
  display: block;
  width: 15px;
  height: 15px;
  font-style: normal;
}
.res-scrap { color: #ffa040; }
.res-crystal { color: #2ee6c8; }
.res-flux { color: #c26aff; }
.hud-hint {
  position: absolute; right: 34px; top: 48px;
  font-size: 9.5px; letter-spacing: 0.24em; text-transform: uppercase;
  opacity: 0.45; text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/ui/styles/hud-overlays.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,kBAAkB,EAAE,QAAQ;EAC5B,6FAA6F;EAC7F,UAAU,EAAE,6BAA6B;AAC3C;AACA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,4FAA4F;EAC5F,UAAU;AACZ;AACA,uBAAuB,4CAA4C,EAAE;AACrE,qBAAqB,WAAW,aAAa,EAAE,EAAE,MAAM,YAAY,EAAE,EAAE;AACvE;EACE,kBAAkB,EAAE,QAAQ;EAC5B,4HAA4H;EAC5H,UAAU,EAAE,6BAA6B;EACzC,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa,EAAE,SAAS,EAAE,eAAe;EACzC,eAAe,EAAE,sBAAsB;AACzC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA,aAAa,cAAc,EAAE;AAC7B,eAAe,cAAc,EAAE;AAC/B,YAAY,cAAc,EAAE;AAC5B;EACE,kBAAkB,EAAE,WAAW,EAAE,SAAS;EAC1C,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACnE,aAAa,EAAE,iBAAiB;AAClC","sourcesContent":["/* damage + boost overlays */\n.vignette-damage {\n  position: absolute; inset: 0;\n  background: radial-gradient(ellipse at center, transparent 52%, rgba(255, 30, 20, 0.55) 100%);\n  opacity: 0; transition: opacity 0.1s ease;\n}\n.vignette-lowhull {\n  position: absolute; inset: 0;\n  background: radial-gradient(ellipse at center, transparent 58%, rgba(255, 30, 20, 0.4) 100%);\n  opacity: 0;\n}\n.vignette-lowhull.on { animation: lowhull 1.2s ease-in-out infinite; }\n@keyframes lowhull { 0%, 100% { opacity: 0.12; } 50% { opacity: 0.5; } }\n.vignette-jump {\n  position: absolute; inset: 0;\n  background: radial-gradient(ellipse at center, rgba(210, 245, 255, 0.95) 0%, rgba(120, 200, 255, 0.6) 55%, transparent 100%);\n  opacity: 0; transition: opacity 0.5s ease;\n  pointer-events: none;\n}\n\n/* HUD resources */\n.resource-line {\n  display: flex; gap: 16px; margin-top: 4px;\n  font-size: 12px; letter-spacing: 0.12em;\n}\n.resource-line span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n.resource-line span i {\n  display: block;\n  width: 15px;\n  height: 15px;\n  font-style: normal;\n}\n.res-scrap { color: #ffa040; }\n.res-crystal { color: #2ee6c8; }\n.res-flux { color: #c26aff; }\n.hud-hint {\n  position: absolute; right: 34px; top: 48px;\n  font-size: 9.5px; letter-spacing: 0.24em; text-transform: uppercase;\n  opacity: 0.45; text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
